import React, { useState } from 'react';
import { Form, Input, Button, Row, Col } from 'antd';
import './ForgotPassword.css';
import OtpInput from 'react-otp-input';
import axios from 'axios';
import key from '../../key';
import { notification } from 'antd';

const ForgotPassword = () => {
    const [step, setStep] = useState(1);
    const [otp, setOtp] = useState();
    const [email, setEmail] = useState();
    const [generatedOTP, setGeneratedOTP] = useState();

    const onFinishEmail = async (values) => {
        setEmail(values.email);
        try {
            const res = await axios.post(`${key}/api/user/check-email`, {
                email: values.email
            });
            if (res.data.status) {
                notification.success({
                    message: 'OTP sent successfully!',
                });
                // math.random() function to generate 4 digit OTP
                const otpp = Math.floor(1000 + Math.random() * 9000);
                setGeneratedOTP(otpp);
                await axios.post(`${key}/api/email/send-otp`, {
                    email: values.email,
                    otp: otpp,
                });
                setStep(2);
            }else{
                notification.error({
                    message: 'Email not found!',
                });
            }
        } catch (error) {
            notification.error({
                message: 'Email not found!',
            });
        }
    };

    const onFinishOTP = () => {
        // Handle OTP submission
        //eslint-disable-next-line
        if (otp == generatedOTP) {
            notification.success({
                message: 'OTP verified successfully!',
            });
            setStep(3);
        } else {
            notification.error({
                message: 'OTP not verified!',
            });
        }

    };

    const onFinishNewPassword = async (values) => {
        try {
            const res = await axios.put(`${key}/api/user/change-forget-password`, {
                email: email,
                password: values.password,
            });
            console.log(res.data)
            if (res.data.success) {
                notification.success({
                    message: 'Password updated successfully!',
                });
                window.location.reload();
            } else {
                notification.error({
                    message: 'Password not updated!',
                });
            }
        } catch (error) {
            notification.error({
                message: 'Password not updated!',
            });
        }
    };

    const renderStepContent = () => {
        switch (step) {
            case 1:
                return (
                    <Form className='email_form' name="forgot_password_form" onFinish={onFinishEmail}>
                        <Form.Item
                            name="email"
                            label="Email"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your email!',
                                },
                                {
                                    type: 'email',
                                    message: 'Please enter a valid email address!',
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                Continue
                            </Button>
                        </Form.Item>
                    </Form>
                );
            case 2:
                return (
                    <Form>
                        <div className='head'>Enter the 4-Digit OTP</div>
                        <div className='d-flex justify-content-center'>
                            <OtpInput
                                value={otp}
                                onChange={setOtp}
                                numInputs={4}
                                renderSeparator={<span>-</span>}
                                renderInput={(props) => <input {...props} />}
                                // inputType='number'
                                inputStyle='otp-input'
                            />
                        </div>
                        <div className='d-flex justify-content-center'>
                            <Button type="primary" onClick={onFinishOTP}>
                                Continue
                            </Button>
                        </div>
                    </Form>
                );
            case 3:
                return (
                    <Form name="forgot_password_new_password_form" onFinish={onFinishNewPassword}>
                        <Form.Item
                            name="password"
                            label="New Password"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please enter a new password!',
                                },
                            ]}
                            hasFeedback
                        >
                            <Input.Password />
                        </Form.Item>
                        <Form.Item
                            name="confirmPassword"
                            label="Confirm Password"
                            dependencies={['password']}
                            hasFeedback
                            rules={[
                                {
                                    required: true,
                                    message: 'Please confirm your password!',
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('password') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject('The two passwords do not match!');
                                    },
                                }),
                            ]}
                        >
                            <Input.Password />
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                Update Password
                            </Button>
                        </Form.Item>
                    </Form>
                );
            default:
                return null;
        }
    };

    return (
        <div>
            <Row justify="center">
                <Col span={12}>
                    <h2 className='text-center'>Forgot Password</h2>
                    {renderStepContent()}
                </Col>
            </Row>
        </div>
    );
};

export default ForgotPassword;
